export default class AttachmentForm {
  public filename: string
}
